import 'glider-js';
import '../../../node_modules/glider-js/glider-compat.min.js';

const caroucelItem = document.querySelector('.js-caroucel');

window.addEventListener('DOMContentLoaded', function(){
  new Glider(caroucelItem, {
    slidesToShow: 'auto',
    slidesToScroll: 'auto',
    itemWidth: 110,
    exactWidth: true,
    draggable: true,
    dots: '.glider-dots',
    arrows: {
      prev: '.glider-prev',
      next: '.glider-next'
    },
    responsive: [
      {
        breakpoint: 834,
        settings: {
          itemWidth: 250,
        }
      },
      {
        breakpoint: 1196,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          itemWidth: 0,
          exactWidth: false,
        }
      }
    ]
  });
});

// load後にフェード表示
caroucelItem.addEventListener('glider-slide-visible', function(event){
  caroucelItem.classList.add('loaded');
});

